import {
  getFindAllVenueRentalConfigurationsQueryKey,
  useUpdateVenueRentalConfigurations,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { BatchEditRentalConfigurationFormValuesType } from '../../components';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_RENTAL_CONFIGURATION';

type UseUpdateRentalConfigurationsArgsType = {
  venueId: string;
  version: string;
};

type HandleUpdateArgsType = {
  data: BatchEditRentalConfigurationFormValuesType;
  configurationIds: string[];
};

type UseUpdateRentalConfigurationsReturnType = {
  updateRentalConfigurations: (args: HandleUpdateArgsType) => Promise<void>;
};

export const useUpdateRentalConfigurations = ({
  venueId,
  version,
}: UseUpdateRentalConfigurationsArgsType): UseUpdateRentalConfigurationsReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutateAsync: mutateUpdate } = useUpdateVenueRentalConfigurations();
  const { invalidateQuery: invalidateConfigurationQueries } =
    useInvalidateQuery(
      getFindAllVenueRentalConfigurationsQueryKey(venueId, version)
    );

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateConfigurationQueries();
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const updateRentalConfigurations = async ({
    data,
    configurationIds,
  }: HandleUpdateArgsType) => {
    await mutateUpdate(
      {
        venueId,
        data: {
          ...data,
          configurationIds,
        },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateRentalConfigurations };
};
